import {withAvatar} from 'Common/helpers/withAvatar';
import {withBirthDate} from 'Common/helpers/withBirthDate';
import IFoundExcludeHorse from 'ExcludeHorse/models/IFoundExcludeHorse';

export function convertServerSimpleHorse(horse: IFoundExcludeHorse): IFoundExcludeHorse {
  return {
    ...withAvatar(withBirthDate(horse)),
  };
}
